//(function () {
'use strict';

angular.module('eltazkara.topBar')
    .controller('TopBarController', TopBarController)
    .factory('RegistrationService', RegistrationService)
    .factory('stateService', stateService)
    .directive('dismissMenu', dismissMenu)
    //.directive('dismissPopup', dismissPopup)
    .directive('myEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.myEnter);
                    });
                    event.preventDefault();
                }
            });
        }
    });

TopBarController.$inject = [
    '$rootScope',
    '$scope',
    'Auth',
    '$cookies',
    '$location',
    '$timeout',
    'RegistrationService',
    'UserData',
    'Category',
    'AuthServerProvider',
    '$window',
    '$document',
    '$state',
    '$stateParams',
    '$http',
    'SearchData',
    'User',
    'FB_APP_ID'
];
function TopBarController(
    $rootScope,
    $scope,
    Auth,
    $cookies,
    $location,
    $timeout,
    RegistrationService,
    UserData,
    Category,
    AuthServerProvider,
    $window,
    $document,
    $state,
    $stateParams,
    $http,
    SearchData,
    User,
    FB_APP_ID) {
    var vm = this;
    vm.searchEndpoint = window.search;
    
    $rootScope.isMobile = window.mobileAndTabletcheck = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    vm.showVerify = User.getShowVerify();

    //AI: If iphone safari
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    if (iOS && webkit && iOSSafari) {
        //AI: The following listener to stop the pinch-to-zoom in iphone/ipad Safari
        document.documentElement.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, false);

        //AI: The following listener to stop the double-tap-to-zoom in iphone/ipad Safari
        var lastTouchEnd = 0;

        document.documentElement.addEventListener('touchend', function (event) {
            var now = (new Date()).getTime();
            if (now - lastTouchEnd <= 300) {
                event.preventDefault();
            }
            lastTouchEnd = now;
        }, false);
    }

    //AI: This is for login/signup switcher in small devices that can't hold two views at the same time
    $rootScope.signUpView = true;

    vm.initLoginView = function () {
        $rootScope.clientWidth = 0;
        vm.resizeHandler();
    };

    vm.resizeHandler = function () {
        //Solve mobile browsers bug when it trigger resize on scroll
        if (window.innerWidth != $rootScope.clientWidth) {
            $rootScope.clientWidth = window.innerWidth;
            if ($rootScope.clientWidth <= 768)
                $rootScope.signUpView = false
            else
                $rootScope.signUpView = true;
        }
    };

    vm.openMobileMenu = function () {
        $rootScope.mobileMenuOpen = true;
    };

    vm.closeMobileMenu = function () {
        $rootScope.mobileMenuOpen = false;
    };

    vm.toggleLoginView = function () {
        $rootScope.signUpView = !$rootScope.signUpView;
    };

    vm.forgotPassword = false;
    
    vm.forgotPasswordToggler = function () {
        vm.forgotPassword = !vm.forgotPassword;
        vm.resetPasswordEmailNotExist = false;
        vm.resetPasswordEmailSubmitted = false;
        vm.resetPasswordEmailSent = false;
        vm.resetpasswordemail = null;
        vm.mailSendSuccessfully = false;
        $rootScope.userLoginError = false;
    };

    //Initialize Login/Signup View
    vm.initLoginView();

    $(window).resize(function () {
        vm.resizeHandler();
        //AI:Rootscope must be updated to avoid resize bug like mobile/tablet rotation
        $rootScope.$apply();
    });

    $rootScope.userMenu = false;

    vm.toggleUserMenu = function () {
        $rootScope.userMenu = !$rootScope.userMenu;
    };

    vm.default = {};

    //used root scope to send this variable to index (Advised by Islam Taha)
    $rootScope.loginPanelActive = false;

    vm.toggleLoginPanel = function () {
        if ($rootScope.clientWidth > 768 || ($rootScope.clientWidth <= 768 && $rootScope.signUpView)) {
            document.getElementById("ufullname").value = "";
            document.getElementById("uphone").value = "";
            document.getElementById("uemail").value = "";
            document.getElementById("upass").value = "";
            document.getElementById("confirmpass").value = "";

            if (!$rootScope.loginPanelActive) {
                vm.registrationSubmitted = false;
            }
        }

        if (($rootScope.clientWidth > 768 || ($rootScope.clientWidth <= 768 && !$rootScope.signUpView)) && !vm.forgotPassword) {
            document.getElementById("userLoginEmail").value = "";
            document.getElementById("userLoginPassword").value = "";
            document.getElementById("userLoginRemember").checked = false;
        }

        vm.confirmedPasswordError = false;
        vm.forgotPassword = false;
        vm.resetPasswordEmailNotExist = false;
        vm.resetpasswordemail = null;
        vm.resetPasswordEmailSubmitted = false;
        vm.resetPasswordEmailSent = false;
        vm.mailSendSuccessfully = false;
        vm.resetpasswordemail = null;
        vm.userClaimChecked = false;
        $rootScope.loginPanelActive = !$rootScope.loginPanelActive;
        $rootScope.userLoginError = false;
        vm.User = {};
        vm.errors = {};
        $rootScope.$emit('app:loginPanelToggled');
    };

    //This function for UI simulation ONLY and MUST BE DELETED
    vm.tempChangeTheme = function (theme) {
        $rootScope.theme = theme;
    };

    vm.regex = {};
    vm.credentials = {};
    vm.CategoriesList = [];

    vm.getNumber = function (num) {
        return new Array(num);
    };

    vm.childernLength = [];
    vm.number = [];

    vm.getsubcategory = function () {
        Category.getAllCategories({})
            .$promise.then(function (data) {
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        var tempItem = {
                            "categoryId": data[i].CategoryId,
                            "Name": data[i].ParentCategory,
                            "Theme": data[i].Theme,
                            "ChildCategories": data[i].ChildCategories,
                        };
                        vm.childernLength[i] = data[i].ChildCategories.length;
                        vm.number[i] = Math.ceil(vm.childernLength[i] / 6);
                        vm.CategoriesList[i] = tempItem;
                    }
                }

            }, function (error) { })
    };

    vm.getsubcategory();
    vm.isLoggedIn = false;

    vm.checkLogin = function () {
        if (AuthServerProvider.getToken() == undefined)
            vm.isLoggedIn = false;
        else
            vm.isLoggedIn = true;
    };

    vm.checkLogin();
    var accountText = UserData.getKey("Name", "Login");
    $rootScope.accountText = accountText.split(" ")[0];
    $rootScope.logoutText = UserData.getKey("LogoutText", "");

    vm.regex = {
        //Name: /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/,
        //Name: /^[a-z]*( [a-z]+)$/,
        //Name: /^[a-z]*( )$/,
        //Name: /\b[^\d\s]+\b/g,
        Name: /\s/g,
        Email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]+$/
    };

    vm.submitText = "Sign Up";
    vm.existPhone = false;
    vm.existEmail = false;
    vm.registrationSubmitted = false;
    vm.registrationSent = false;
    vm.confirmedPasswordError = false;
    vm.logoutText = UserData.getKey("LogoutText", "");
    vm.fbAppId = FB_APP_ID;
    vm.loginError = "";
    $rootScope.userLoginError = false;
    vm.errors = {};

    vm.User = {
        Name: "",
        MobileNumber: "+20",
        Email: "",
        Password: "",
        ConfirmPassword: ""
    };

    //Save Data
    vm.SaveData = function (registrationForm) {
        vm.registrationSubmitted = true;

        if (registrationForm.$valid && vm.submitText == 'Sign Up' && vm.userClaimChecked) {
            vm.registrationSent = true;
            vm.submitText = 'Please Wait...';

            User.CheckEmailPhone({ "MobileNumber": vm.User.MobileNumber, "Email": vm.User.Email })
                .$promise.then(function (data) {
                    if (data) {
                        if (data["email"] == "true")
                            vm.existEmail = true;
                        else
                            vm.existEmail = false;

                        if (data["mobileNumber"] == "true")
                            vm.existPhone = true;
                        else
                            vm.existPhone = false;

                        if (vm.existPhone == true || vm.existPhone == true) return;
                    }
                }, function (error) {
                    vm.registrationSent = false;
                    vm.submitText = "Sign Up";
                });

            var data = {};
            var user = vm.User;
            data.User = user;

            RegistrationService.SaveFormData(data).then(function (d) {
                if (typeof (d) === 'object') {
                    UserData.set(d);
                    vm.toggleLoginPanel();
                    $cookies.put('SmsSent', 'true');
                    $rootScope.redirectVerifyAfterLogin = true;
                    vm.doUserLogin(data);

                    if (d == 'mobile used') {
                        vm.errors.MobileNumber = "Mobile number is already registered.";
                    }
                    else if (d == 'email used') {
                        //alert(d);s
                        vm.errors.Email = "Email address is already registered."
                    }
                }
                vm.registrationSent = false;
                vm.submitText = "Sign Up";
            }, function (error) {
                vm.registrationSent = false;
                vm.submitText = "Sign Up";
            });
        }
    };

    vm.logout = function () {
        Auth.logout();
        $rootScope.loggedOut = true;
    };

    $rootScope.loginClick = false;
    $rootScope.LoginSubmit = "Login";

    vm.doUserLogin = function (userData) {
        vm.data = {};

        if (userData) {
            vm.credentials.userLoginEmail = userData.User.MobileNumber;
            vm.credentials.userLoginPassword = userData.User.Password;
            vm.credentials.userLoginRemember = false;
            vm.data.Body = "username=" + vm.credentials.userLoginEmail + "&password=" + encodeURIComponent(vm.credentials.userLoginPassword)
                + "&grant_type=password" + "&client_id=ngAuthApp" + "&client_secret=0";

            if (vm.credentials.userLoginRemember == null)
                vm.data.rememberMe = false;
            else
                vm.data.rememberMe = true;

            Auth.login(vm.data);
        }
        else {
            vm.credentials.userLoginEmail = document.getElementById("userLoginEmail").value;
            vm.credentials.userLoginPassword = document.getElementById("userLoginPassword").value;
            vm.credentials.userLoginRemember = document.getElementById("userLoginRemember").value;
            vm.data.Body = "username=" + vm.credentials.userLoginEmail + "&password=" + encodeURIComponent(vm.credentials.userLoginPassword)
                + "&grant_type=password" + "&client_id=ngAuthApp" + "&client_secret=0";

            if (vm.credentials.userLoginRemember == null)
                vm.data.rememberMe = false;
            else
                vm.data.rememberMe = true;

            User.IsUserBlocked({ "User": vm.credentials.userLoginEmail, "Password": encodeURIComponent(vm.credentials.userLoginPassword) })
                .$promise.then(function (data) {
                    if (data.status == "true") {
                        $rootScope.PopUpTitle = "Login Error";
                        $rootScope.PopUpDescription = "Please Contact Admin, Your Email Is Blocked";
                        $rootScope.PopError = true;
                    }
                    else {
                        if ($rootScope.loginClick == false) {
                            $rootScope.LoginSubmit = "Please Wait...";
                            $rootScope.loginClick = true;
                            Auth.login(vm.data);
                        }
                    }
                }, function (error) { });
        }
    }

    vm.countDownCounter = 5;

    vm.countDown = function () {
        if (vm.forgotPassword && vm.countDownCounter > 0) {
            $timeout(function () {
                vm.countDownCounter--;
                vm.countDown();
            }, 1000)
        }
        else {
            vm.forgotPassword = vm.mailSendSuccessfully = false;
            vm.countDownCounter = 5;
        }
    };

    vm.resetpasswordemail = "";
    vm.ResetPassowrdButtonText = "Send";

    vm.resetpassword = function (resetPasswordForm) {
        vm.resetPasswordEmailSubmitted = true;

        if (resetPasswordForm.$valid) {
            if (vm.ResetPassowrdButtonText == "Send") {
                vm.ResetPassowrdButtonText = "Wait..";
                vm.resetPasswordEmailSent = true;

                User.ResetPasswordUsingMail({ "Email": vm.resetpasswordemail })
                    .$promise.then(function (data) {
                        if (data) {
                            if (data.status === "No user account is associated with this email") {
                                vm.resetPasswordEmailNotVerified = false;
                                vm.resetPasswordEmailNotExist = true;
                                vm.mailSendSuccessfully = false;
                            }
                            else if (data.status === "Mail was sent successfully") {
                                vm.resetPasswordEmailNotVerified = false;
                                vm.resetPasswordEmailNotExist = false;
                                vm.mailSendSuccessfully = true;
                                vm.countDown();
                            }

                            vm.ResetPassowrdButtonText = "Send";
                            vm.resetPasswordEmailSent = false;
                        }
                    }, function (error) {
                        vm.resetPasswordEmailSent = false;
                    });
            }
        }
    };

    vm.itemSelected = function (item) {
        if (item.originalObject) {
            var selectedItem = item.originalObject;
            if (selectedItem.type == 'Performance')
                location.href = "#/performance/" + selectedItem.id + "";
            else if (selectedItem.type == 'Performer')
                location.href = "#/performer/" + selectedItem.id + "";
            else if (selectedItem.type == 'Venue')
                location.href = "#/venue/" + selectedItem.id + "";
            else if (selectedItem.type == 'Event')
                location.href = "#/event/" + selectedItem.id + "";
        }
    };

    vm.searchResult = function () {
        var text = document.getElementById('headerSearchField_value').value;

        if (text && text.length > 2) {
            $http({
                url: window.search + text,
                method: "GET"
            }).then(function (response) {
                var res = response.data;

                if (res != "NotValid") {
                    SearchData.setData(res);
                    var currentState = $state.current.name;

                    if (currentState == 'search')
                        $rootScope.initSearchPage();
                    else
                        location.href = "/#search";
                }
            });
        }
    };

    //Check if logged in
    if ($rootScope.User) {
        if ($rootScope.User.Name)
            $rootScope.User.Name = $rootScope.User.Name.split(" ")[0];
        else
            vm.isLoggedIn = false;
    }
    else
        vm.isLoggedIn = false;

    vm.confirmedPasswordFunc = function () {
        if (vm.User.ConfirmPassword == vm.User.Password) {
            vm.confirmedPasswordError = false;
            vm.confirmPassEmpty = false;
        }
        else if (vm.User.ConfirmPassword == "") {
            vm.confirmedPasswordError = false;
            vm.confirmPassEmpty = true;
        }
        else {
            vm.confirmedPasswordError = true;
            vm.confirmPassEmpty = false;
        }
    };

    $rootScope.isArabic = function (text) {
        if (typeof (text) == 'undefined') return;
        var firstChar = text.substr(0, 1);
        return /[\u0600-\u06FF]/.test(firstChar);
    };
};

function RegistrationService($http, $q) {
    var fac = {};

    fac.SaveFormData = function (data) {
        var defer = $q.defer();
        $http({
            url: window.backendUrl + "Users/Register",
            method: 'POST',
            data: JSON.stringify(data),
            crossDomain: true,
            withCredentials: false,
            headers: { 'content-type': 'application/json' }
        }).success(function (d) {
            defer.resolve(d);
        }).error(function (e) {
            console.log('Error', e);
            defer.reject(e);
        });

        return defer.promise;
    }

    return fac;
}

function dismissMenu($rootScope, $document) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            $document.bind('click', function (event) {
                if ($rootScope.userMenu) {
                    if (element.find(event.target).length > 0) return;
                    $rootScope.$apply(function () {
                        $rootScope.userMenu = false;
                    });
                };
            });
        }
    };
};

function stateService($rootScope, $state) {
    var from, to;

    $rootScope.$on("$stateChangeSuccess", function (event, fromState, toState) {
        from = fromState.name;
    });

    return {
        getPrev: function () {
            return from;
        }
    }
}
